import {
  STATUSES,
  makeListState,
  makeDataState,
  makePaginationState,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  storyAds: makePaginationState(),
  eventCheck: {},
  episodes: makePaginationState(),
  vouchers: makeListState(),
  recommendationVoucher: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_STORY_ADS}_PENDING`:
      return {
        ...state,
        storyAds: {
          ...state.storyAds,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORY_ADS}_SUCCESS`:
      return {
        ...state,
        storyAds: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.storyAds.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_STORY_ADS}_ERROR`:
      return {
        ...state,
        storyAds: {
          ...state.storyAds,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    case `${t.CREATE_STORY_AD}_SUCCESS`:
      return {
        ...state,
        storyAds: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.storyAds.pagination,
            items: concatUnique(
              [action.payload.result],
              state.storyAds.pagination.items
            ),
          },
        },
      };

    case `${t.PATCH_STORY_AD}_SUCCESS`: {
      const { storyAdId, status } = action.meta;
      return {
        ...state,
        storyAds: {
          ...state.storyAds,
          pagination: {
            ...state.storyAds.pagination,
            items: state.storyAds.pagination.items.map((item) => {
              if (item.id === storyAdId) {
                return { ...item, status };
              }

              return item;
            }),
          },
        },
      };
    }

    case t.RESET:
      return {
        ...state,
        storyAds: makePaginationState(),
      };

    case `${t.FETCH_STORY_AD_EVENT_CHECK}_PENDING`:
      return {
        ...state,
        eventCheck: {
          [action.meta.name]: makeDataState(),
        },
      };

    case `${t.FETCH_STORY_AD_EVENT_CHECK}_SUCCESS`:
      return {
        ...state,
        eventCheck: {
          [action.meta.name]: {
            status: STATUSES.SUCCESS,
            isLoaded: true,
            data: action.payload.result,
          },
        },
      };

    case `${t.FETCH_EPISODES}_PENDING`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_EPISODES}_SUCCESS`:
      return {
        ...state,
        episodes: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.episodes.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };

    case `${t.FETCH_STORY_AD_VOUCHERS}_SUCCESS`:
      return {
        ...state,
        vouchers: {
          ...state.vouchers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_STORY_AD_VOUCHER_RECOMMENDATION}_SUCCESS`:
      return {
        ...state,
        recommendationVoucher: {
          ...state.recommendationVoucher,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyAd/reducer.js